import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';

@Injectable()
export class TestService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    public testAPI(): Observable<any> {
        let apiUrl = `${environment.apiUrl}/test`;
        if (environment.mockData) {
            apiUrl = 'mock-data/test.json';
        }

        this.setHttpOptions();
        return this.http.get<any>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
}
